function Dropdown(props) {
  const data = props.data;
  const changeFunction = props.onChange;
  let key = props.keyword;

  if (key === "category") {
    return (
      <div class="form-group row">
        <label className="col-sm-3 col-form-label">Category</label>
        <div class="col-sm-9">
          <select
            class="form-control form-control-lg "
            onChange={changeFunction}
          >
            <option value={""}>select category</option>
            {data.length > 0 &&
              data.map((item) => {
                return <option value={item.id}>{item.name}</option>;
              })}
          </select>
        </div>
      </div>
    );
  }

  if (key === "inner_category") {
    return (
      <div class="form-group row">
        <label className="col-sm-3 col-form-label">
          Menu Category
          <span className="required">*</span>
        </label>
        <div class="col-sm-9">
          <select
            class="form-control form-control-lg "
            onChange={changeFunction}
          >
            <option value={""}>---select inner category---</option>
            {data.length > 0 &&
              data.map((item) => {
                return <option value={item.id}>{item.name}</option>;
              })}
          </select>
        </div>
      </div>
    );
  }

  if (key === "variant") {
    return (
      <div class="form-group row">
        <label className="col-sm-3 col-form-label">variant</label>
        <div class="col-sm-9">
          <select
            class="form-control form-control-lg default-select "
            onChange={changeFunction}
          >
            {props.varientData.map((item) => {
              return <option value={item.value}>{item.name}</option>;
            })}
          </select>
        </div>
      </div>
    );
  }

  if (key === "product") {
    return (
      <div class="form-group row">
        <label className="col-sm-3 col-form-label">
          Products
          <span className="required">*</span>
        </label>
        <div class="col-sm-9">
          <select
            class="form-control form-control-lg  "
            onChange={changeFunction}
          >
            <option value={""}>--select item--</option>
            {props.data.map((item) => {
              return <option value={item.id}>{item.name}</option>;
            })}
          </select>
        </div>
      </div>
    );
  }

  if (key === "offer_products") {
    return (
      <div class="form-group row">
        <label className="col-sm-3 col-form-label">
          Products
          <span className="required">*</span>
        </label>
        <div class="col-sm-9">
          <select
            class="form-control form-control-lg  "
            onChange={changeFunction}
          >
            <option value={""}>--select item--</option>
            {props.data.map((item) => {
              return <option value={item.item.id}>{item.item.name}</option>;
            })}
          </select>
        </div>
      </div>
    );
  }

  if (key === "status") {
    return (
      <div class="form-group row mt-2">
        <div class="col-sm-6">
          <select
            class="form-control form-control-lg default-select "
            onChange={(e) => props.onChange(e.target.value)}
          >
            {props.data.map((item) => {
              return <option value={item.id}>{item.name}</option>;
            })}
          </select>
        </div>
        <div class="col-sm-6">
          <input
            class="form-control form-control-lg default-select "
            onChange={(e) => props.onChange(e.target.value)}
            placeholder="your reason"
          />
        </div>
      </div>
    );
  }

  if (key === "restaurant") {
    return (
      <div class="form-group row">
        <label className="col-sm-3 col-form-label">
          Restaurants
          <span className="required">*</span>
        </label>
        <div class="col-sm-9">
          <select
            class="form-control form-control-lg  "
            onChange={changeFunction}
          >
            <option value={""}>--select restaurant--</option>
            {props.data.map((item) => {
              return (
                <option value={item.id} data-item={JSON.stringify(item)}>
                  {item.name}
                </option>
              );
            })}
          </select>
        </div>
      </div>
    );
  }

  if (key === "franchise") {
    return (
      <div class="form-group row">
        <label className="col-sm-3 col-form-label">
          Franchise
          <span className="required">*</span>
        </label>
        <div class="col-sm-9">
          <select
            class="form-control form-control-lg default-select "
            onChange={changeFunction}
          >
            <option value={""}>--select item--</option>
            {props.data.map((item) => {
              return <option value={item.id}>{item.name}</option>;
            })}
          </select>
        </div>
      </div>
    );
  }

  if (key === "restaurant_offer") {
    return (
      <div class="form-group row">
        <label className="col-sm-3 col-form-label">
          Restaurant Banners
          <span className="required">*</span>
        </label>
        <div class="col-sm-9">
          <select
            class="form-control form-control-lg  "
            onChange={changeFunction}
          >
            <option value={""}>--select restaurant offer--</option>
            {props.data.map((item) => {
              return <option value={item.id}>{item.branch.name}</option>;
            })}
          </select>
        </div>
      </div>
    );
  }

  if (key === "product_offer") {
    return (
      <div class="form-group row">
        <label className="col-sm-3 col-form-label">
          Product Banners
          <span className="required">*</span>
        </label>
        <div class="col-sm-9">
          <select
            class="form-control form-control-lg default-select "
            onChange={changeFunction}
          >
            <option value={""}>--select product banner--</option>
            {props.data.map((item) => {
              return <option value={item.id}>{item.heading}</option>;
            })}
          </select>
        </div>
      </div>
    );
  }
}

export default Dropdown;
